import { ETopic } from '../../../types/topic';
import { prepareLoginIssueTypeSubject } from './prepareLoginIssueTypeSubject';
import { prepareDefaultSubject } from './prepareDefaultSubject';
export function prepareSubject(formValue) {
  switch (formValue.topic) {
    case ETopic.Login:
      return prepareLoginIssueTypeSubject(formValue);
  }
  return prepareDefaultSubject(formValue);
}